module.exports = __webpack_public_path__ + "static/media/preRefrence.218a356e.png";